export enum SubjectRelationType {
    ProductionSite = 1,
    Affiliate = 2,
    XRef = 3,
}
